document.addEventListener('DOMContentLoaded', function () {
  const lightbox = document.createElement('div');
  lightbox.className = 'custom-product-lightbox';
  lightbox.setAttribute('aria-hidden', 'true');

  lightbox.innerHTML = `
    <button
      type="button"
      class="custom-product-lightbox__close"
      aria-label="Zamknij powiększone zdjęcie"
    >
      &times;
    </button>

    <img
      class="custom-product-lightbox__image"
      src=""
      alt=""
    >
  `;

  document.body.appendChild(lightbox);

  const lightboxImage = lightbox.querySelector(
    '.custom-product-lightbox__image'
  );

  const closeButton = lightbox.querySelector(
    '.custom-product-lightbox__close'
  );

  function isProductImage(image) {
    if (!image || image.tagName !== 'IMG') {
      return false;
    }

    return Boolean(
      image.closest(
        '.product, .product-media, .product__media, .product-gallery, ' +
        '.product-single, [data-product-gallery], [data-product-media]'
      ) ||
      image.src.includes('/products/')
    );
  }

  function getLargeImageUrl(image) {
    const source =
      image.currentSrc ||
      image.getAttribute('data-zoom') ||
      image.getAttribute('data-src') ||
      image.src;

    if (!source) {
      return '';
    }

    try {
      const url = new URL(source, window.location.origin);

      url.searchParams.delete('width');
      url.searchParams.delete('height');
      url.searchParams.set('width', '2000');

      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function openLightbox(image) {
    const imageUrl = getLargeImageUrl(image);

    if (!imageUrl) {
      return;
    }

    lightboxImage.src = imageUrl;
    lightboxImage.alt = image.alt || 'Powiększone zdjęcie produktu';

    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('custom-lightbox-open');
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('custom-lightbox-open');

    setTimeout(function () {
      lightboxImage.src = '';
    }, 200);
  }

  document.addEventListener('click', function (event) {
    const image = event.target.closest('img');

    if (!isProductImage(image)) {
      return;
    }

    event.preventDefault();
    openLightbox(image);
  });

  closeButton.addEventListener('click', closeLightbox);

  lightbox.addEventListener('click', function (event) {
    if (
      event.target === lightbox ||
      event.target === lightboxImage
    ) {
      closeLightbox();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeLightbox();
    }
  });
});